module.exports = __webpack_public_path__ + "static/quote1-d706c7782b4fe84da8bf2f008ba2820a.jpeg";